import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Form,
  Modal,
} from "react-bootstrap";
import { FaTrash, FaEdit, FaEye } from "react-icons/fa";
import { BiRupee } from "react-icons/bi";
import "./CustomerList.css";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import axios from "axios";

const parsePossibleDate = (value) => {
  // Accepts dd/mm/yyyy, d/m/yyyy or yyyy-mm-dd
  if (!value) return null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value); // ISO
  const parts = value.split("/");
  if (parts.length === 3) {
    const d = parseInt(parts[0], 10);
    const m = parseInt(parts[1], 10) - 1;
    const y = parseInt(parts[2], 10);
    const dt = new Date(y, m, d);
    if (!isNaN(dt)) return dt;
  }
  const dt = new Date(value);
  return isNaN(dt) ? null : dt;
};

const Salary = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const [search, setSearch] = useState("");
  const [fromDate, setFromDate] = useState(""); // yyyy-mm-dd
  const [toDate, setToDate] = useState(""); // yyyy-mm-dd

  const [salaryData, setSalaryData] = useState([]);

  const parseDateDMY = (value) => {
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return new Date(value);
    const sep = value.includes("-") ? "-" : value.includes("/") ? "/" : null;
    if (sep) {
      const parts = value.split(sep);
      if (parts.length === 3 && parts[2].length === 4) {
        const d = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10) - 1;
        const y = parseInt(parts[2], 10);
        const dt = new Date(y, m, d);
        return isNaN(dt) ? null : dt;
      }
    }
    const dt = new Date(value);
    return isNaN(dt) ? null : dt;
  };

  useEffect(() => {
    axios.post(`${API_BASE_URL}salary_sf_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {

          const list = response.data.body;

          setSalaryData(list);
          // setRecords(list);

          console.log("test", list);  // now NOT empty

          // const found = list.find(r => Number(r.user_id) === userId) || null;
          // setRecord(found);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setSalaryData([]);
          // setRecords([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setSalaryData([]);
        // setRecords([]);
      });
  }, []);

  // const calculateSalary = (item) => {
  //   const workingDays = item.totalDays - item.lop;
  //   const gross = item.actualSalary;
  //   const basic = gross;
  //   const hra = (gross * item.hraPercent) / 100;
  //   const epf = (gross * item.epfPercent) / 100;
  //   const savings = (gross * item.savingsPercent) / 100;
  //   const iste = (gross * item.istePercent) / 100;
  //   const totalDeduction = epf + savings + item.others;
  //   const netSalary = gross - totalDeduction;

  //   return { workingDays, gross, basic, hra, epf, savings, iste, totalDeduction, netSalary };
  // };

  // const handleDelete = (id) => {
  //   setSalaryData(salaryData.filter((item) => item.id !== id));
  // };

  // filtering logic: search (name/designation) + optional date range filter on doj
  const filteredData = salaryData.filter((item) => {
    // search match
    if (search) {
      const q = search.toLowerCase();
      const nameMatch = item.name && item.name.toLowerCase().includes(q);
      const desigMatch = item.designation && item.designation.toLowerCase().includes(q);
      if (!nameMatch && !desigMatch) return false;
    }

    // date range match (if either fromDate or toDate provided)
    if (fromDate || toDate) {
      const reqDate = parseDateDMY(item.added_date);
      if (!reqDate) return false;
      if (fromDate) {
        const from = new Date(fromDate + "T00:00:00");
        if (reqDate < from) return false;
      }
      if (toDate) {
        const to = new Date(toDate + "T23:59:59");
        if (reqDate > to) return false;
      }
    }

    return true;
  });

  // Pagination over filtered results (consistent with other pages)
  const {
    currentPage,
    totalPages,
    currentItems,
    handlePageChange,
    indexOfFirstItem,
  } = usePagination(filteredData, 25); // show 2 rows per page

  const handleExport = () => {
     console.log("asfsffasdfaf", fromDate, toDate);
    console.log("SF Salary CSV sheet");

    axios({
      url: `${API_BASE_URL}salary_excel.php`, // your PHP export URL
      data: {
        from_date: fromDate,
        to_date: toDate
      },
      method: 'POST', // or GET depending on your PHP script
      responseType: 'blob', // important for file download
    })
      .then((response) => {
        // Create a Blob from the response
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        // Change filename to .csv
        link.setAttribute('download', 'salary_sheet.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading CSV:", error);
      });
  };

  return (
    <>
      <Container fluid className="my-4 outer-container">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
          <p></p>
          <h2>Self Financing Staff Salary Sheet</h2>
          <Button
            variant="success"
            onClick={handleExport}
          // href="/mnt/data/your_excel_file.xlsx"  // <-- replace with your local Excel file path or URL
          // target="_blank"
          // rel="noopener noreferrer"
          // download  // Optional: triggers download instead of open in new tab
          >
            Export to Excel
          </Button>
        </div>
        {/* {currentItems.length === 0 && (
          <Container fluid className="outer-container my-4">
            <Row>
              <Col>
                <div className="not-found-box">Loading...</div>
              </Col>
            </Row>
          </Container>
        )} */}
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label>Search</Form.Label>
            <Form.Control
              type="text"
              placeholder="Search by name or designation"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>

          <Col md={4}>
            <Form.Label>From</Form.Label>
            <Form.Control
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </Col>

          <Col md={4}>
            <Form.Label>To</Form.Label>
            <Form.Control
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </Col>
        </Row>

        <div className="table-pagination-wrapper">
          <div className="table-pagination-content">
            <Table bordered responsive className="table-striped customer-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <th>Designation / Dept.</th>
                  <th>DOJ</th>
                  <th>Actual Salary</th>
                  <th>Total Days</th>
                  <th>LoP</th>
                  <th>Working Days</th>
                  <th>Total Deduction</th>
                  <th>Net Salary</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.map((item, i) => {
                  // const calc = calculateSalary(item);
                  return (
                    <tr key={item.salary_id}>
                      {/* <td>{indexOfFirstItem + i + 1}</td> */}
                      <td>{currentItems.length - (indexOfFirstItem + i)}</td>
                      <td>{item.name}</td>
                      <td>{item.desig_name} - {item.depart_name}</td>
                      <td>{item.date_of_join}</td>
                      <td>
                        <BiRupee />
                        {item.actual}
                      </td>
                      <td>{item.total_days}</td>
                      <td>{item.lop}</td>
                      <td>{item.working_days}</td>
                      <td>
                        <BiRupee />
                        {item.deduction}
                      </td>
                      <td>
                        <BiRupee />
                        {item.net_salary}
                      </td>
                      <td className="action-icons">
                        <Link to={`/viewsalary/${item.salary_id}`}>
                          <FaEye className="view-icon" />
                        </Link>
                        {/* <Link to={`/editsalary/${item.id}`}>
                          <FaEdit className="edit-icon" />
                        </Link>
                        <FaTrash className="delete-icon" onClick={() => handleDelete(item.id)} /> */}
                      </td>
                    </tr>
                  );
                })}

                {currentItems.length === 0 && (
                  <tr>
                    <td colSpan="11" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </Container>

      {/* Modal to Add Staff */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Staff</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Add staff form fields here */}
            <Button className="esimate-btn" onClick={handleClose}>
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Salary;
